export default __webpack_public_path__ + "static/media/greeting22.e36eb17b.png";